import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '48px', marginBottom: '48px' }}>
          {/* About */}
          <div>
            <h3 className="heading-3" style={{ marginBottom: '16px' }}>Delhi Guided Tours</h3>
            <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
              Premium heritage and cultural tours in New Delhi. Small-group experiences led by expert storytellers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px', color: 'var(--text-primary)' }}>Quick Links</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Link to="/weekend-tour" data-testid="footer-weekend-tour-link" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Weekend Tour</Link>
              <Link to="/weekly-tours" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Weekly Tours</Link>
              <Link to="/private-tours" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Private Tours</Link>
              <Link to="/golden-triangle" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Golden Triangle</Link>
              <Link to="/about" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>About Us</Link>
              <Link to="/contact" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Contact</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: '16px', fontWeight: '500', marginBottom: '16px', color: 'var(--text-primary)' }}>Contact Us</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Phone size={16} color="var(--text-secondary)" />
                <a href="tel:+917827327243" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>+91 7827 327 243</a>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Mail size={16} color="var(--text-secondary)" />
                <a href="mailto:joshuaguides247@gmail.com" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>joshuaguides247@gmail.com</a>
              </div>
              <div style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
                <MapPin size={16} color="var(--text-secondary)" style={{ marginTop: '2px' }} />
                <span className="body-small" style={{ color: 'var(--text-secondary)' }}>New Delhi, India</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: '1px solid var(--border-light)', paddingTop: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <Link to="/terms" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Terms & Conditions</Link>
            <Link to="/refund-policy" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Refund Policy</Link>
            <Link to="/privacy-policy" className="body-small" style={{ color: 'var(--text-secondary)', textDecoration: 'none', transition: 'color 0.2s' }}>Privacy Policy</Link>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <p className="body-small" style={{ color: 'var(--text-light)' }}>
              © {new Date().getFullYear()} Delhi Guided Tours. All rights reserved.
            </p>
            <p className="body-small" style={{ color: 'var(--text-light)' }}>
              Founded by Joshua Massey
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;